export default {"src":"/_next/static/media/hero.ce5aa48c.svg","height":406,"width":430,"blurWidth":0,"blurHeight":0};